import { render, staticRenderFns } from "./privacy_agreement.vue?vue&type=template&id=1777d287&scoped=true"
import script from "./privacy_agreement.vue?vue&type=script&lang=js"
export * from "./privacy_agreement.vue?vue&type=script&lang=js"
import style0 from "./privacy_agreement.vue?vue&type=style&index=0&id=1777d287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1777d287",
  null
  
)

export default component.exports